// extracted by mini-css-extract-plugin
export default {"accordion":"KnowledgeBase_accordion__-fdhL","accordionHeader":"KnowledgeBase_accordionHeader__xbDF4"};